import React from 'react';

function MapMarkerHomeIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="#374957"
        d="M12 .007a10 10 0 00-7.063 17.078L12 23.993l7.071-6.916a10 10 0 00-7.07-17.07zm5.665 15.648L12 21.2l-5.657-5.537a8 8 0 1111.322-.008zm-1.647-8.232l-2.5-1.91a2.507 2.507 0 00-3.035 0l-2.5 1.91A2.513 2.513 0 007 9.409V14h10V9.409a2.515 2.515 0 00-.982-1.986zM15 12h-2v-2h-2v2H9V9.409a.5.5 0 01.2-.4L11.7 7.1a.5.5 0 01.608 0l2.5 1.91a.5.5 0 01.2.4L15 12z"
      ></path>
    </svg>
  );
}

export default MapMarkerHomeIcon;
